/* Quick view ("Ver rápido") for product cards.
   Opens a bottom sheet (mobile) / modal (desktop) fed by /products/{handle}.js,
   with quantity stepper and add-to-cart that re-renders and opens the cart drawer.
   Trigger: any element with [data-qv-trigger][data-qv-handle][data-qv-url]. */
(function () {
  var overlay = null;
  var lastFocus = null;

  function formatBRL(cents) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var text = (d.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 180 ? text.slice(0, 180).trim() + '\u2026' : text;
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function close() {
    if (!overlay) return;
    var o = overlay;
    overlay = null;
    o.classList.remove('qv-open');
    document.body.classList.remove('qv-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { o.remove(); }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(handle, url, trigger) {
    if (!handle) return;
    lastFocus = trigger;
    overlay = document.createElement('div');
    overlay.className = 'qv-overlay';
    overlay.innerHTML =
      '<div class="qv-sheet" role="dialog" aria-modal="true" aria-label="Visualiza\u00e7\u00e3o r\u00e1pida">' +
      '<button type="button" class="qv-close" aria-label="Fechar">&times;</button>' +
      '<div class="qv-loading">Carregando&hellip;</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.classList.add('qv-lock');
    requestAnimationFrame(function () { if (overlay) overlay.classList.add('qv-open'); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.qv-close').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.qv-close').focus();

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { if (overlay) render(p, url); })
      .catch(function () {
        if (!overlay) return;
        var l = overlay.querySelector('.qv-loading');
        if (l) l.textContent = 'N\u00e3o foi poss\u00edvel carregar o produto.';
      });
  }

  function render(p, url) {
    var sheet = overlay.querySelector('.qv-sheet');
    var img = p.images && p.images[0] ? p.images[0] : null;
    var variants = p.variants || [];
    var selected = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { selected = variants[i]; break; }
    }
    if (!selected && variants.length) selected = variants[0];

    var html =
      '<button type="button" class="qv-close" aria-label="Fechar">&times;</button>' +
      '<div class="qv-body">' +
      (img
        ? '<div class="qv-img"><img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy" width="400" height="400"></div>'
        : '') +
      '<div class="qv-info">' +
      '<h3 class="qv-title">&nbsp;</h3>' +
      '<p class="qv-price"><span class="qv-price-val"></span><span class="qv-compare"></span></p>' +
      '<p class="qv-desc">&nbsp;</p>' +
      '</div></div>';

    if (variants.length > 1) {
      html += '<select class="qv-variants" aria-label="Op\u00e7\u00f5es">';
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        html +=
          '<option value="' + v.id + '"' +
          (v.available ? '' : ' disabled') +
          (selected && v.id === selected.id ? ' selected' : '') + '>' +
          String(v.title).replace(/</g, '&lt;') +
          (v.available ? '' : ' \u2014 esgotado') +
          '</option>';
      }
      html += '</select>';
    }

    html +=
      '<div class="qv-actions">' +
      '<span class="qv-qty"><button type="button" data-qv-minus aria-label="Diminuir">&minus;</button>' +
      '<input type="number" value="1" min="1" inputmode="numeric" aria-label="Quantidade">' +
      '<button type="button" data-qv-plus aria-label="Aumentar">+</button></span>' +
      '<button type="button" class="qv-add"' + (selected && selected.available ? '' : ' disabled') + '>' +
      (selected && selected.available ? 'Adicionar ao carrinho' : 'Esgotado') +
      '</button>' +
      '</div>' +
      '<a class="qv-link" href="' + url + '">Ver detalhes completos</a>' +
      '<p class="qv-error" hidden>&nbsp;</p>';

    sheet.innerHTML = html;
    sheet.querySelector('.qv-title').textContent = p.title || '';
    sheet.querySelector('.qv-desc').textContent = stripHtml(p.description);
    sheet.querySelector('.qv-close').addEventListener('click', close);

    var priceVal = sheet.querySelector('.qv-price-val');
    var compare = sheet.querySelector('.qv-compare');
    function syncPrice() {
      if (!selected) return;
      priceVal.textContent = formatBRL(selected.price);
      compare.textContent =
        selected.compare_at_price && selected.compare_at_price > selected.price
          ? formatBRL(selected.compare_at_price)
          : '';
    }
    syncPrice();

    var sel = sheet.querySelector('.qv-variants');
    var addBtn = sheet.querySelector('.qv-add');
    if (sel) {
      sel.addEventListener('change', function () {
        var id = parseInt(sel.value, 10);
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].id === id) selected = variants[k];
        }
        syncPrice();
        addBtn.disabled = !(selected && selected.available);
        addBtn.textContent = selected && selected.available ? 'Adicionar ao carrinho' : 'Esgotado';
      });
    }

    var qty = sheet.querySelector('.qv-qty input');
    sheet.querySelector('[data-qv-minus]').addEventListener('click', function () {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
    sheet.querySelector('[data-qv-plus]').addEventListener('click', function () {
      qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    var errEl = sheet.querySelector('.qv-error');
    addBtn.addEventListener('click', function () {
      if (!selected || !selected.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adicionando\u2026';
      errEl.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: selected.id,
          quantity: Math.max(1, parseInt(qty.value, 10) || 1),
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error(res.data && res.data.description ? res.data.description : 'Erro ao adicionar.');
          }
          close();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
            drawer.renderContents(res.data);
          }
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = 'Adicionar ao carrinho';
          errEl.textContent = err && err.message ? err.message : 'Erro ao adicionar.';
          errEl.hidden = false;
        });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-qv-trigger]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open(t.getAttribute('data-qv-handle'), t.getAttribute('data-qv-url'), t);
  });
})();
